import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/orcamentosbuilderdashboard",
    name: "OrcamentosBuilderDashboard",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/orcamentosbuilderlst",
    name: "OrcamentosBuilderLst",
    beforeEnter: routeGuard,
    component: () => import("../views/OrcamentosBuilderLst.vue"),
    children: [
      {
        path: ":id",
        component: () => import("../views/OrcamentosBuilderLst.vue"),
      }
    ]
  },
  {
    path: "/orcamentosbuilderfrm",
    name: "OrcamentosBuilderFrm",
    beforeEnter: routeGuard,
    component: () => import("../views/OrcamentosBuilderFrm.vue"),
    children: [
      {
        path: ":id",
        component: () => import("../views/OrcamentosBuilderFrm.vue"),
      }
    ]
	},
  {
    path: "/orcamentosbuilderambientesfrm",
    name: "OrcamentosBuilderAmbientesFrm",
    beforeEnter: routeGuard,
    component: () => import("../views/OrcamentosBuilderAmbientesFrm.vue"),
    children: [
      {
        path: ":id",
        component: () => import("../views/OrcamentosBuilderAmbientesFrm.vue"),
      }
    ]
  },
  {
    path: "/orcamentobuildercorporativo",
    name: "OrcamentoBuilderCorporativo",
    beforeEnter: routeGuard,
    component: () => import("../views/OrcamentoBuilderCorporativo.vue"),
    children: [
      {
        path: ":id",
        component: () => import("../views/OrcamentoBuilderCorporativo.vue"),
      }
    ]
  }
];
